const CHAT_HASH = 'chat'

export const hasChatHash = () => {
  return window.location.hash.includes(CHAT_HASH)
}
